import React from 'react';
import dayjs from 'dayjs';
import css from './Filters.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import { setFilters } from '../../../../store/reducers/filtersSlice';
import { parseDate } from '../../../../utils/common';
import DatePicker from '../../../../components/DatePicker';
import { TextField } from '@mui/material';

export const Filters = () => {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.filtersReducer);

  return (
    <div className={css.root}>
      <DatePicker
        value={[
          filters.dateFrom ? dayjs(filters.dateFrom) : null,
          filters.dateTo ? dayjs(filters.dateTo) : null,
        ]}
        setDateRange={(value) => {
          dispatch(
            setFilters({
              ...filters,
              dateFrom: value[0] ? parseDate(dayjs(value[0]).toDate(), "yyyy-MM-dd'T'HH:mm") : '',
              dateTo: value[1] ? parseDate(dayjs(value[1]).toDate(), "yyyy-MM-dd'T'HH:mm") : '',
            })
          );
        }}
      />
      {/* <TextField
        value={filters.bankId || ''}
        className={css.inputText}
        onChange={({ target: { value } }) => dispatch(setFilters({ ...filters, bankId: value }))}
        label="Bank"
      /> */}
      <TextField
        value={filters.clientName || ''}
        className={css.inputText}
        onChange={({ target: { value } }) => dispatch(setFilters({ ...filters, clientName: value }))}
        label="Client"
      />
      <TextField
        value={filters.amountFrom || ''}
        className={css.inputText}
        onChange={({ target: { value } }) => dispatch(setFilters({ ...filters, amountFrom: value }))}
        label="Amount from"
      />
      <TextField
        value={filters.amountTo || ''}
        className={css.inputText}
        onChange={({ target: { value } }) => dispatch(setFilters({ ...filters, amountTo: value }))}
        label="Amount to"
      />
    </div>
  );
};
